export interface ComparisonRow {
  topic: string
  without: string
  with: string
}

export const comparison: ComparisonRow[] = [
  {
    topic: 'Planificación semanal',
    without: '8 a 10 horas por semana buscando ideas',
    with: '10 minutos: eliges, adaptas y enseñas',
  },
  {
    topic: 'Estructura del año',
    without: 'Improvisas según la semana',
    with: 'Año entero mapeado desde el primer día',
  },
  {
    topic: 'Progresión motriz',
    without: 'Los estudiantes repiten los mismos ejercicios',
    with: 'Progresión lógica y medible',
  },
  {
    topic: 'Evaluación',
    without: 'Solo notas subjetivas',
    with: 'Rúbricas objetivas más informes',
  },
  {
    topic: 'Confianza en clase',
    without: 'Llegas sin un plan claro',
    with: 'Entras sabiendo exactamente qué hacer',
  },
  {
    topic: 'Participación del grupo',
    without: 'Se aburren y baja la participación',
    with: 'Piden que la clase no termine',
  },
  {
    topic: 'Conversación con familias',
    without: '“Le va bien” o “necesita mejorar”',
    with: 'Datos concretos de progreso',
  },
  {
    topic: 'Tu carga emocional',
    without: 'Alta: siempre estás preparando algo',
    with: 'Baja: el sistema funciona en automático',
  },
]
